import Validate from "./Validate.js";
import { scrollToElement } from "./Util";
import { createInputmask } from "./Inputmask";

class Form {
    constructor(form) {
        this.$form = $(form);
        this.$formInnerWrap = this.$form.find(".js-form-inner");
        this.$formSuccesWrap = this.$form.find(".js-form-success");
        this.$btn = this.$form.find(".js-submit");
        this.validator = "";
        /*this.recaptcha;*/

        //this.popLabels();
        this.popLabelsHandle();
        this.validate();
        //this.initRecaptcha();
        this.bindSubmit();
        this.bindReset();
        this.bindClose();
        this.disableAutoFill();
        this.disableIEautocomplete();
        this.fileUpload();
        this.filterPhone();
        this.spamCheck();
        this.bindInputmask();
    }

    // Валидация
    validate() {
        this.validator = new Validate(this.$form);
    }

    // Инициализируем рекапчу
    /*initRecaptcha() {
        const $container = this.$form.find('.js-recaptcha');

        this.recaptcha = grecaptcha.render($container.attr('id'), {
            'sitekey': $container.data('sitekey'),
            'size': 'invisible',
            'callback': () => {
                this.sendForm();
            },
            'error-callback': () => {
                // Ошибка на стороне рекапчи
                this.$form
                    .removeClass('_success')
                    .addClass('_error');

                console.log('recaptcha error');
            }
        });
    }*/

    bindReset() {
        this.$form.find(".js-form-ok-btn").on("click", (e) => {
            this.resetForm();

            e.preventDefault();
        });
    }

    // Событие отправки
    bindSubmit() {
        this.$form.on("submit", (e) => {
            e.preventDefault();

            this.validator.validateAllFields();

            if (this.validator.isValid()) {
                this.sendForm();
            } else {
                const el = this.$form.find(".input-wraps");
                el.scrollTop(0);
                // scrollToElement(this.$form.find("._error").first());
            }
            // Блокируем кнопку сабмита
            /*this.$btn.attr('disabled', true);*/

            // Запускаем проверку рекапчи
            //grecaptcha.execute(this.recaptcha);
        });
    }

    // Отправка
    sendForm() {
        this.$form.ajaxSubmit({
            url: this.$form.attr("action"),
            dataType: "json",
            // data: this.$form.serialize(),
            type: this.$form.attr("method") || "GET",
            cache: false,
            success: (response) => {
                if (!response.success) {
                    console.log("asd");
                    // Ошибка на сервере
                    App.H.removeClass("_form-success").addClass(
                        "_form-error _form-message"
                    );

                    // Разблокируем кнопку
                    this.$btn.removeAttr("disabled");
                } else {
                    console.log("asd");
                    // Успех!
                    this.resetForm();

                    App.H.removeClass("_form-error").addClass(
                        "_form-success _form-message"
                    );

                    this.$formInnerWrap.addClass("_hidden");
                    this.$formSuccesWrap.addClass("_showen");
                    this.$form.css({
                        minHeight: this.$formSuccesWrap.outerHeight(),
                    });
                    this.$formInnerWrap.slideUp();
                }

                // Автоматически закрываем сообщения
                // setTimeout(() => {
                // this.$form.removeClass('_success _error');
                // }, 5000);
            },
            error: () => {
                // Ошибка отправки

                App.H.removeClass("_form-success").addClass(
                    "_form-error _form-message"
                );

                // Разблокируем кнопку
                this.$btn.removeAttr("disabled");

                // Автоматически закрываем сообщения
                // setTimeout(() => {
                // this.$form.removeClass('_success _error');
                // }, 5000);
            },
        });
    }

    // Закрытие формы
    bindClose() {
        App.H.find(".js-form-ok").on("click", function (e) {
            e.preventDefault();
            App.H.removeClass("_form-success _form-error _form-message");
        });
    }

    // Загрузка файла
    fileUpload() {
        this.$form.find(".js-upload").on("change", function () {
            const $input = $(this);
            const $label = $input
                .closest(".input-wrap")
                .find(".js-upload-label");
            const val = $input.val();
            let fileName;

            if (val.length) {
                fileName = val.split("\\").pop() || "";
                $label.text(fileName);
                $input.addClass("_active");
            } else {
                $label.text($label.data("text"));
                $input.removeClass("_active");
            }
        });

        this.$form.find(".js-upload-clear").on("click", function () {
            $(this).siblings(".js-upload").val("").change();
        });
    }

    // Для поля телефона допускаем только цифры, пробел и +-()
    filterPhone() {
        this.$form.find("[data-phone]").on("input", function () {
            const val = $(this)
                .val()
                .replace(/[^0-9\s()+-]/g, "");
            $(this).val(val);
        });
    }

    // Сброс формы
    resetForm() {
        this.$form[0].reset();

        this.$form
            .find(".js-upload")
            .val("")
            .change()
            .siblings("[data-label]")
            .text("");

        // this.$form.removeClass('_success _error');

        this.$form
            .find("[data-required]")
            .not(":checkbox")
            .addClass("_notvalidated")
            .removeClass("_error");

        this.$form
            .find(":checkbox[data-required]")
            .not(":checked")
            .addClass("_notvalidated");

        /*this.$form
            .find('.js-submit')
            .attr('disabled', true);*/

        this.$form.find(".js-input-wrap").removeClass("_focused");

        this.$form.find(".js-dropdown").trigger("dropdown:reset");

        //grecaptcha.reset(this.recaptcha);

        this.$formInnerWrap.removeClass("_hidden");
        this.$formSuccesWrap.removeClass("_showen");
        this.$formInnerWrap.show();
    }

    popLabelsHandle() {
        const $inputs = this.$form.find("input.js-input, textarea.js-input");

        $inputs.on("input", (e) => {
            const $el = $(e.currentTarget);

            this.popLabels($el);
        });

        $inputs
            .focus((e) => {
                const $el = $(e.currentTarget);

                this.popLabels($el, true);
            })
            .blur((e) => {
                const $el = $(e.currentTarget);

                $el.closest(".js-input-wrap").removeClass("_ready-for-input");
                this.popLabels($el);
            });
    }

    // Подсказки для инпутов
    popLabels(el, isFocus) {
        const val = $.trim(el.val());

        if (isFocus) {
            el.closest(".js-input-wrap").addClass("_ready-for-input");
            return false;
        }

        if (!val.length || val == "+7() --") {
            el.closest(".js-input-wrap").removeClass("_focused");
        } else {
            el.closest(".js-input-wrap").addClass("_focused");
        }
    }

    // Отключаем автозаполнение полей в хроме
    disableAutoFill() {
        this.$form
            .find(
                '[type="text"], [type="email"], [type="tel"], [type="password"]'
            )
            .attr("autocomplete", "new-password");
    }

    // Фикс autocomplete="off" для IE и Edge
    disableIEautocomplete() {
        if (App.ie || App.edge) {
            window.onbeforeunload = function () {
                $('form[autocomplete="off"]').each(function () {
                    this.reset();
                });
            };
        }
    }

    // Защита от спама (если нет рекапчи)
    spamCheck() {
        App.secondsOnPage = 0;

        // Проверка phantomJS
        let isBot = function () {
            var retval = false;

            if (window._phantom || window.callPhantom) retval = true;
            if (window.__phantomas) retval = true; //PhantomJS-based web perf metrics + monitoring tool
            if (window.Buffer) retval = true; //nodejs
            if (window.emit) retval = true; //couchjs
            if (window.spawn) retval = true; //rhino
            if (window.webdriver) retval = true; //selenium
            if (window.domAutomation || window.domAutomationController)
                retval = true; //chromium based automation driver
            // if (window.outerWidth === 0 && window.outerHeight === 0) retval = true; //headless browser

            return retval;
        };

        if (isBot()) {
            return false;
        }

        // Считаем, сколько времени пользователь провёл на сайте, и отправляем это в форме
        let name = this.$form.data("name");
        this.$form.append(
            `<input type="hidden" name="${name}" class="js-input-seconds" value="0" />`
        );

        clearInterval(App.antispamTimeout);
        App.antispamTimeout = setInterval(() => {
            App.secondsOnPage += 0.4;
            this.$form.find(".js-input-seconds").val(App.secondsOnPage);
        }, 1000);
    }

    bindInputmask() {
        createInputmask('phone');
    }

    // checkSpam() {
    //     const $inputs = this.$form.find("input.js-input, textarea.js-input");
    //     $inputs.on("click", () => {
    //         this.spamCheck();
    //     });
    // }
}

const $forms = $(".js-form");

if ($forms.length) {
    $forms.each(function () {
        new Form(this);
    });
}



// WEBPACK FOOTER //
// ./_src/js/Form.js